<template>
  <v-card class="pa-5 card-shadow" rounded="0">
    <v-row no-gutters justify="start">
      <back-btn class="hide-on-print" />
    </v-row>
    <v-row class="mt-4">
      <overlay :show="loading" text="Cargando..." />
      <v-col
        v-for="(box, index) in boxes"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <resource-card
          :title="box.title"
          text="DESCARGAR PDF"
          :url="box.fileUrl"
          :policy-type="box.deliveryPolicy"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';
  import ResourceCard from './ResourceCard.vue';
  import Overlay from '@/components/Overlay';

  export default {
    name: 'CardPolicies',
    components: {
      ResourceCard,
      Overlay,
    },
    data() {
      return {
        boxes: [],
        loading: false,
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),

      userChannel() {
        return this.user?.VTWEG;
      },
    },
    mounted() {
      this.getPolicies();
    },
    methods: {
      async getPolicies() {
        this.loading = true;
        try {
          const policies = await axios.get('/get-regulatory-policies', {
            params: {
              channel: this.userChannel,
            },
          });
          this.boxes = policies.data.data;
        } catch (error) {
          this.$toast.error('Ocurrió un error al consultar las políticas');
        }
        this.loading = false;
      },
    },
  };
</script>
